import React, { useState, useEffect } from "react";
//routes
import {
  BrowserRouter as Router,
  Switch,
  Route,
  useLocation,
} from "react-router-dom";

import { isMobile } from "react-device-detect";

// components
import CustomCursor from "./components/cursor/customCursor";
import SplashScreen from "./components/splashScreen";
import Footer from "./components/footer";
import Header from "./components/header";
import Credits from "./components/credits";
import IndexNav from "./components/indexNav";

// styles
import "./styles/index.scss";
import Chapter from "./components/chapter";

//context
import {
  useGlobalDispatchContext,
  useGlobalStateContext,
} from "./context/globalContext";

//motion
import { AnimatePresence } from "framer-motion";

function App() {
  const [endSplashScreen, setEndSplashScreen] = useState(false);
  const { cursorStyles } = useGlobalStateContext();
  const dispatch = useGlobalDispatchContext();

  const onCursor = (cursorType) => {
    cursorType = (cursorStyles.includes(cursorType) && cursorType) || false;
    dispatch({ type: "CURSOR_TYPE", cursorType: cursorType });
  };

  useEffect(() => {
    setTimeout(() => {
      setEndSplashScreen(true);
    }, 6750);
  }, []);

  return (
    <>
      <Router basename={"/nasa"}>
        {!isMobile && <CustomCursor />}
        <AnimatePresence exitBeforeEnter>
          {!endSplashScreen ? (
            <SplashScreen key="splashscreen" />
          ) : (
            <MainNav onCursor={onCursor} />
          )}
        </AnimatePresence>
      </Router>
    </>
  );
}

export default App;

const MainNav = ({ onCursor }) => {
  let location = useLocation();
  const [show, setShow] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      setShow(true);
    }, 1000);
  }, []);

  return (
    <>
      <Header onCursor={onCursor} />
      {show && (
        <AnimatePresence exitBeforeEnter>
          <Switch location={location} key={location.pathname}>
            <Route exact path="/">
              <IndexNav
                onMouseEnter={() => onCursor("drag")}
                onMouseLeave={onCursor}
              />
            </Route>
            <Route exact path="/chapter/:id">
              <Chapter />
            </Route>
            <Route exact path="/credits">
              <Credits />
            </Route>
          </Switch>
        </AnimatePresence>
      )}

      <Footer />
    </>
  );
};
